import(/* webpackMode: "eager" */ "/home/foneorders.com/app/src/app/register/page.tsx");
